/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

// Register multimethods
import "~/sources/bsky/auth";
import "~/sources/bsky/config";
import "~/sources/bsky/source-settings";

import "~/sources/hn/config";
import "~/sources/hn/source-settings";

import "~/sources/reddit/config";
import "~/sources/reddit/source-settings";

import "~/sources/slack/config";
import "~/sources/slack/source-settings";

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
